import { computed as i, createBlock as c, openBlock as o, normalizeClass as r, withCtx as h, createElementBlock as m, Fragment as v, createTextVNode as k, toDisplayString as w } from "vue";
import L from "../../atoms/anchor-element/anchor-element.vue.js";
import O from "../../atoms/text-icon-element/text-icon-element.vue.js";
import { useLazyUrl as j } from "../../composables/useLazyUrl.js";
const S = /* @__PURE__ */ Object.assign({
  name: "DsLink"
}, {
  __name: "link",
  props: {
    /**
     * trackingData, to be set as data-track attributes for tracking purpose
     */
    trackingData: { type: Object, default: () => ({}) },
    /**
     * Link url, href attribute content
     */
    url: {
      type: String,
      required: !1,
      default: "",
      validator: (t, n) => n.type === "button" && !t ? !0 : !!t
    },
    /**
     * Link openInNewWindow, when is set to true it will open the link in a new window
     */
    openInNewWindow: { type: Boolean, default: !1 },
    /**
     * Link nuxt, when is set to true it will render a nuxt link (vue router link)
     */
    nuxt: { type: Boolean, default: !1 },
    /**
     * Link prefetch, when is set to true it will nuxt will prefetch the page
     */
    prefetch: { type: Boolean, default: !1 },
    /**
     * Link ariaLabel, arial-label attribute content
     */
    ariaLabel: { type: String, default: "" },
    /**
     * Lazy route endpoint
     */
    lazyUrlEndpoint: {
      type: String,
      default: ""
    },
    /**
     * Link text or icon object
     */
    content: {
      type: [String, Object],
      required: !0,
      validator: (t) => t instanceof Object ? ["name", "category", "ariaLabel"].every((n) => n in t) : !0
    },
    /**
     * Link text size (if set to true, it will set heading-xsmall font size)
     */
    heading: {
      type: Boolean,
      default: !1
    },
    /**
     * Link left icon (optional)
     */
    iconLeft: {
      type: [Object, null],
      default: null,
      validator: (t) => ["name", "category"].every((n) => n in t)
    },
    /**
     * Link right icon (optional)
     */
    iconRight: {
      type: [Object, null],
      default: null,
      validator: (t) => ["name", "category"].every((n) => n in t)
    },
    /**
     * Link look (button or link style)
     */
    type: {
      type: String,
      default: "link",
      validator: (t) => ["button", "link"].includes(t)
    },
    /**
     * Link variant (primary, secondary, tertiary, quaternary, quinary)
     */
    variant: {
      type: String,
      default: "primary",
      validator: (t) => ["primary", "secondary", "tertiary", "quaternary", "quinary", "circle-icon"].includes(t)
    },
    /**
     * Link color (green, white, black...)
     */
    color: {
      type: String,
      default: "green",
      validator: (t) => ["black", "green", "white", "white-green", "black-green", "grey"].includes(t)
    },
    /**
     * download, adds download attribute
     */
    download: { type: Boolean, default: !1 },
    /**
     * moveIconOnHover, if set to false the icon will not move on hover
     */
    moveIconOnHover: { type: Boolean, default: !0 }
  },
  emits: ["link-clicked"],
  setup(t) {
    const n = t, e = i(() => n.content && n.content instanceof Object), u = i(() => n.content && n.content instanceof Object ? n.content.ariaLabel : n.ariaLabel || n.content), d = i(() => n.lazyUrlEndpoint), { lazyUrl: s } = j(d), f = i(() => n.url || s.value), y = i(() => e.value || n.iconLeft || n.iconRight), g = (l) => {
      const a = ["chevron-right-small", "chevron-right", "chevron-left", "chevron-left-small"];
      return l === "right" ? n.iconRight && a.includes(n.iconRight.name) : n.iconLeft && a.includes(n.iconLeft.name);
    };
    return (l, a) => (o(), c(L, {
      class: r([
        { "ds-button-link--chevron": g("right"), "ds-button-link--static-icon": !t.moveIconOnHover },
        // Link Type
        {
          [`ds-button-icon ds-button-icon--${n.variant} ds-button-icon--${n.color}`]: t.type === "button" && e.value,
          [`ds-button ds-button--${n.variant} ds-button--${n.color}`]: t.type === "button" && !e.value,
          [`ds-button-link ds-button-link--${n.variant} ds-button-link--${n.color}`]: t.type === "link" && t.variant !== "circle-icon",
          "ds-button-circle-icon ds-button-circle-icon--light": t.variant === "circle-icon"
        },
        // Icon padding
        {
          "ds-button--with-icon-left": t.iconLeft,
          "ds-button--with-icon-right": t.iconRight
        }
      ]),
      "tracking-data": { "component-name": l.$options.name, ...t.trackingData },
      url: f.value,
      "open-in-new-window": t.openInNewWindow,
      nuxt: t.nuxt,
      prefetch: t.prefetch,
      "aria-label": u.value,
      download: t.download,
      "data-j-link": "",
      onLinkClicked: a[0] || (a[0] = (b) => l.$emit("link-clicked", b))
    }, {
      default: h(() => [
        y.value ? (o(), c(O, {
          key: 0,
          class: r({ "ds-heading-xsmall": t.heading && t.type === "link" }),
          "icon-left": t.iconLeft ? t.iconLeft : null,
          "icon-right": t.iconRight ? t.iconRight : null,
          text: e.value ? null : t.content,
          icon: e.value ? t.content : null,
          "with-spacing": t.type === "button",
          "data-j-link-text": ""
        }, null, 8, ["class", "icon-left", "icon-right", "text", "icon", "with-spacing"])) : (o(), m(v, { key: 1 }, [
          k(w(t.content), 1)
        ], 64))
      ]),
      _: 1
    }, 8, ["class", "tracking-data", "url", "open-in-new-window", "nuxt", "prefetch", "aria-label", "download"]));
  }
});
export {
  S as default
};
